

import {
  CHANGE_RADIO, CLEAR_DATA,
  LOAD_HB_INDEX_CHART_DATA_ERROR,
  LOAD_HB_INDEX_CHART_DATA_REQUEST, LOAD_HB_INDEX_CHART_DATA_SUCCESS
} from "./hb-index-chart-action-creators";

const initialState = {
  data: null,
  loading: false,
  radio: null,
  selectedRadio: "",
  error: ""
};


export default ( state = initialState, action ) => {

  const { data, radio, selectedRadio, error } = action;

  switch(action.type) {

    case CLEAR_DATA:
      return {
        ...state,
        data: null
      };

    case CHANGE_RADIO:
      return {
        ...state,
        selectedRadio: radio
      };

    case LOAD_HB_INDEX_CHART_DATA_REQUEST:
      return {
        ...state,
        loading: true
      };

    case LOAD_HB_INDEX_CHART_DATA_ERROR:
      return {
        ...state,
        error,
        loading: false
      };

    case LOAD_HB_INDEX_CHART_DATA_SUCCESS:
      return {
        ...state,
        error: "",
        data,
        radio,
        selectedRadio,
        loading: false
      };


    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/hb-index-chart/hb-index-chart-reducer.js